import { Injectable } from '@angular/core';
// import Uppy from 'uppy/lib/core'
// import Dashboard from 'uppy/lib/plugins/Dashboard'
// import Tus10 from 'uppy/lib/plugins/Tus10'
// import Informer from 'uppy/lib/plugins/Informer'
// import MetaData from 'uppy/lib/plugins/MetaData'
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FileUploadService {

  alahamora = '';
  client = filestack.init(this.alahamora);


  constructor(private http: HttpClient) {

  }

  showPicker() {
    return this.client.pick({})
  }


}
